<script>
export default {
    props: {
        title: {},
        value: {}
    }
};
</script>

<template>
    <div class="card border-0 dash-card micro-card">
        <div class="card-body">
            <div class="card__value">{{ value }}</div>
            <div class="card__title">{{ title }}</div>
        </div>
    </div>
</template>

<style lang="scss">
.micro-card {
    .card-body {
        padding: 5px 0px 5px 0px !important;
    }

    .card__value {
        font-size: 14px;
        text-align: center;
    }

    .card__title {
        border-top: 1px solid $gray-300;
        margin-top: 4px;
        padding-top: 4px;
        text-align: center;
        font-size: 10px;
        color: $gray-600;
        font-weight: 600;
    }
}
</style>
